import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Col,
  Row,
  Spin,
  Modal,
  Checkbox,
  message,
} from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  PhoneOutlined,
  MailOutlined,
} from "@ant-design/icons";
import "./login.less";
import { REPASSWORD, GET_EMAIL_CODE } from "../../api/login";
import cookie from "react-cookies";
import moment from "moment";
import uitls from "../../assets/js/public";
import Header from "./header";
import Footer from "./footer";
import Cover from "./cover";

import { useTranslation } from "react-i18next";

const Forget = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [sendDisabled, setSendDisabled] = useState(false);
  const [time, setTime] = useState(0);
  const [formVal, setFormVal] = useState({});

  useEffect(() => {
    if (!!cookie.load("accessToken")) {
      history.push("/index/overview");
    }
  }, []);
  const timer = useRef(null);

  useEffect(() => {
    timer.current && clearInterval(timer.current);
    return () => timer.current && clearInterval(timer.current);
  }, []);

  useEffect(() => {
    if (time === 120)
      timer.current = setInterval(() => setTime((time) => --time), 1000);
    else if (time <= 0) timer.current && clearInterval(timer.current);
  }, [time]);

  const getCode = () => {
    if (time) return;
    //直接使用
    setTime(120);
  };

  const register = async (values) => {
    setLoading(true);
    if (values.password != values.userPwdVeryf) {
      message.error(t("pages.forget.msg1"));
      return false;
    }
    // values = Object.assign(values);
    if (!localStorage.getItem("codeid")) {
      message.error(t("pages.forget.msg2"));
      return false;
    }
    delete values.userPwdVeryf;
    values.code_id = localStorage.getItem("codeid");
    let res = await REPASSWORD(values);
    console.log(res);
    if (res.data.code === 200) {
      message.success(t("pages.forget.msg3"));
      localStorage.removeItem("codeid");
      history.push("/login");
      return;
    }
    message.error(
      t("pages.forget.msg4") + "" + res.data.code + "," + res.data.message
    );
    setLoading(false);
  };

  return (
    <div className="cont">
      <Header />

      <div className="login-cont">
        <Cover />
        <div className="login-sign register">
          {/* <div className="title">
          <h1>找回</h1>
          <p>
            没有账号？
            <Link to="/register">注册</Link>
          </p>
        </div> */}
          <Form
            className="login-form"
            onFinish={register}
            name="normal_login"
            initialValues={{ remember: true }}
            onValuesChange={(vals) => {
              let formVals = { ...formVal, ...vals };
              setFormVal(formVals);
            }}
            layout="vertical"
          >
            <Form.Item
              label={t("pages.forget.label1")}
              name="email"
              rules={[
                {
                  required: true,
                  message: t("pages.forget.label1Placeholder"),
                },
              ]}
            >
              <Input
                size="large"
                allowClear
                prefix={
                  <MailOutlined
                    style={{
                      color: "rgba(0,0,0,.25)",
                      fontSize: "18px",
                    }}
                  />
                }
                placeholder={t("pages.forget.label1Placeholder")}
              />
            </Form.Item>
            <Form.Item
              label={t("pages.forget.label2")}
              name="password"
              rules={[
                {
                  required: true,
                  message: t("pages.forget.label2Placeholder"),
                },
              ]}
            >
              <Input.Password
                size="large"
                allowClear
                prefix={
                  <LockOutlined
                    style={{
                      color: "rgba(0,0,0,.25)",
                      fontSize: "18px",
                    }}
                  />
                }
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                placeholder={t("pages.forget.label2Placeholder")}
              />
            </Form.Item>
            <Form.Item
              label={t("pages.forget.label3")}
              name="userPwdVeryf"
              rules={[
                {
                  required: true,
                  message: t("pages.forget.label3Placeholder"),
                },
              ]}
            >
              <Input.Password
                size="large"
                allowClear
                prefix={
                  <LockOutlined
                    style={{
                      color: "rgba(0,0,0,.25)",
                      fontSize: "18px",
                    }}
                  />
                }
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                placeholder={t("pages.forget.label3Placeholder")}
              />
            </Form.Item>

            <Form.Item label={t("pages.forget.label4")}>
              <Row gutter={8}>
                <Col span={16}>
                  <Form.Item
                    name="code"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: t("pages.forget.label4Placeholder"),
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      allowClear
                      prefix={
                        <MailOutlined
                          style={{
                            color: "rgba(0,0,0,.25)",
                            fontSize: "18px",
                          }}
                        />
                      }
                      placeholder={t("pages.forget.label4Placeholder")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Button
                    size="large"
                    block
                    disabled={(time != 0 && true) || false}
                    onClick={async () => {
                      if (!uitls.isEmail(formVal.email)) {
                        message.error(t("pages.forget.label4Msg1"));
                        return;
                      }

                      if (time <= 0) {
                        let res = await GET_EMAIL_CODE({
                          email: formVal.email,
                          code_type: "password",
                        });
                        console.log(res);
                        if (res.data.code == 200) {
                          message.success(t("pages.forget.label4SendText"));
                          getCode();
                          localStorage.setItem("codeid", moment());
                        } else {
                          message.error(
                            t("pages.forget.label4SendErrText") +
                              "" +
                              res.data.code
                          );
                          setTime(0);
                        }
                      }
                    }}
                  >
                    {time > 0
                      ? time + "" + t("pages.forget.label4Sec")
                      : t("pages.forget.label4Text")}
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                size="large"
                style={{ fontSize: "14px", borderRadius: "5px" }}
                block
              >
                {t("pages.forget.subBtn")}
              </Button>
            </Form.Item>
            <div
              className="after d-flex justify-content-between"
              style={{ color: "rgba(0, 0, 0, 0.45)", marginTop: "15px" }}
            >
              <Link to="/login">{t("pages.forget.btn1")}</Link>
              <Link to="/register">{t("pages.forget.btn2")}</Link>
            </div>
          </Form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Forget;
